import { render, staticRenderFns } from "./CallStatusView.vue?vue&type=template&id=a35e37d4&scoped=true&lang=pug&"
import script from "./CallStatusView.vue?vue&type=script&lang=ts&"
export * from "./CallStatusView.vue?vue&type=script&lang=ts&"
import style0 from "./CallStatusView.vue?vue&type=style&index=0&id=a35e37d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35e37d4",
  null
  
)

export default component.exports